import { render, staticRenderFns } from "./Image.vue?vue&type=template&id=2c11b3b6&scoped=true&"
import script from "./Image.vue?vue&type=script&lang=js&"
export * from "./Image.vue?vue&type=script&lang=js&"
import style0 from "./Image.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Image.vue?vue&type=style&index=1&id=2c11b3b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c11b3b6",
  null
  
)

export default component.exports